// extracted by mini-css-extract-plugin
module.exports = {"PartDiagramViewer":"partviewer_PartDiagramViewer__9cI0v"};